import React from 'react';

export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon</title>
    <path
      d="M0 12h20"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconMinus.jsx